import { install } from './install'

export default class Hades {
  static install = install

  constructor() {}
}
